const DRAWER_SELECTOR = '#NavDrawer.drawer-mobile-v2';

const closePanel = (trigger, panel) => {
  trigger.setAttribute('aria-expanded', 'false');
  trigger.classList.remove('is-open');

  if (!panel) return;

  panel.setAttribute('aria-hidden', 'true');
  panel.classList.remove('is-open');
};

const closeAllPanels = (drawer, animate = true) => {
  if (!animate) {
    drawer.querySelectorAll('.drawer-mobile-v2__subnav').forEach((panel) => {
      panel.style.transition = 'none';
    });
  }

  drawer.querySelectorAll('.drawer-mobile-v2__accordion-trigger').forEach((trigger) => {
    const panelId = trigger.getAttribute('aria-controls');
    const panel = panelId ? document.getElementById(panelId) : null;
    closePanel(trigger, panel);
  });

  if (!animate) {
    requestAnimationFrame(() => {
      drawer.querySelectorAll('.drawer-mobile-v2__subnav').forEach((panel) => {
        panel.style.transition = '';
      });
    });
  }
};

const openPanel = (trigger, panel) => {
  trigger.setAttribute('aria-expanded', 'true');
  trigger.classList.add('is-open');
  panel.setAttribute('aria-hidden', 'false');
  panel.classList.add('is-open');
};

const initMenuMobileAccordion = () => {
  const drawer = document.querySelector(DRAWER_SELECTOR);
  if (!drawer) return;

  const triggers = drawer.querySelectorAll('.drawer-mobile-v2__accordion-trigger');

  triggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const isOpen = trigger.getAttribute('aria-expanded') === 'true';
      const panelId = trigger.getAttribute('aria-controls');
      const panel = panelId ? document.getElementById(panelId) : null;

      closeAllPanels(drawer);

      if (!isOpen && panel) {
        openPanel(trigger, panel);
      }
    });
  });

  const resetOnDrawerClose = () => {
    const isOpen =
      document.body.classList.contains('js-drawer-open-left') ||
      document.documentElement.classList.contains('js-drawer-open-left');

    if (!isOpen) {
      closeAllPanels(drawer, false);
    }
  };

  [document.body, document.documentElement].forEach((node) => {
    const observer = new MutationObserver(resetOnDrawerClose);
    observer.observe(node, { attributes: true, attributeFilter: ['class'] });
  });
};

export default initMenuMobileAccordion;
